import CoreSiteSearch from './CoreSiteSearch';

export { type CoreSiteSearchProps } from './CoreSiteSearch';
export default CoreSiteSearch;
